<div class="footer-section">
  <div class="empty-wrapper d-flex">
    <!-- Page Size Dropdown (Dropup) -->
    <span class="me-2">Records per page</span>
    <div
      class="dropdown dropup"
      [class.show]="isDropdownOpen"
      style="position: relative"
    >
      <button
        class="btn dropdown-toggle-custom d-flex justify-content-between align-items-center"
        style="min-width: 125px; height: 45px; border: 1px solid #dee2e6"
        type="button"
        aria-expanded="false"
        (click)="isDropdownOpen = !isDropdownOpen"
      >
        {{ itemsPerPage }}
        <img
          src="/assets/Icons/dropdown_icon.svg"
          [class.rotated]="isDropdownOpen"
          style="margin-left: 8px; transition: transform 0.3s ease"
        />
      </button>

      <ul
        class="dropdown-menu dropdown-menu-end"
        [class.show]="isDropdownOpen"
        style="bottom: 100%; top: auto"
      >
        <li *ngFor="let pageSize of pageSizes">
          <a class="dropdown-item" (click)="setItemsPerPage(pageSize)">
            {{ pageSize }}
          </a>
        </li>
      </ul>
    </div>
  </div>
  <nav class="pagination-nav d-flex align-items-center gap-3">
    <!-- Page Number Navigation -->
    <ul class="pagination mb-0">
      <!-- Back Button -->
      <li class="page-item" [class.disabled]="currentPage === 1">
        <button
          class="btn page-link arrow-btn"
          style="border-radius: 10px; cursor: pointer"
          (click)="previousPage()"
        >
          <span>
            <img
              src="/assets/Icons/mingcute_right-fill.svg"
              alt=""
              style="transform: rotate(180deg)"
            />
          </span>
        </button>
      </li>

      <!-- Page Numbers -->
      <li class="page-item" *ngFor="let page of pagesToShow">
        <span *ngIf="page === -1" class="page-link">...</span>
        <button
          *ngIf="page !== -1"
          class="btn page-link"
          style="cursor: pointer"
          [ngClass]="{ 'active-page': page === currentPage }"
          (click)="goToPage(page)"
        >
          {{ page }}
        </button>
      </li>

      <!-- Next Button -->
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <button
          class="btn page-link arrow-btn"
          style="border-radius: 10px; cursor: pointer"
          (click)="nextPage()"
        >
          <span
            ><img src="/assets/Icons/mingcute_right-fill.svg" alt=""
          /></span>
        </button>
      </li>
    </ul>
  </nav>
  <div class="result-count">
    <span class="count">
      Showing {{ startRecord }} to {{ endRecord }} of {{ totalRecords }} records
    </span>
  </div>
</div>
